import { useNavigate } from 'react-router';
import { useIntl } from 'react-intl';

// MUI
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import UndoRounded from '@mui/icons-material/UndoRounded';

// screen
import { useTraceabilityBack } from 'modules/suppliers/detail/hooks/useTraceabilityBack';

const BackToSuppliersPageButton = () => {
  const { formatMessage } = useIntl();
  const navigate = useNavigate();
  const { fromFoodTraceability, goBackToTraceability } = useTraceabilityBack();

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: fromFoodTraceability ? 'space-between' : 'flex-end',
        alignItems: 'center',
        mt: 4,
      }}
    >
      {fromFoodTraceability && (
        <Button
          variant="outlined"
          color="error"
          startIcon={<UndoRounded />}
          onClick={() => {
            goBackToTraceability();
          }}
        >
          {formatMessage({ id: 'supplier.backToTraceability' })}
        </Button>
      )}
      <Button
        variant="outlined"
        startIcon={<UndoRounded />}
        onClick={() => {
          navigate(-1);
        }}
      >
        {formatMessage({ id: 'back' })}
      </Button>
    </Box>
  );
};

export default BackToSuppliersPageButton;
